import Components from './../Component';
import Slider from './../components/Slider';
import ViewMore from './../components/ViewMore';

export default class IntranetBus extends Components {

  constructor($) {
    super($);
  }

  init(index, element) {
    this.get(element);
  }

  get(element) {

    this.$.getJSON('/intranet/api/intranetblock?node=' + this.$(element).attr('data-node') + '&block=' + this.$(element).attr('data-block') + '&r=' + Math.round(), function (data) {
      this.$(element).html(data.html);
      var slider = new Slider();
      slider.$ = this.$;
      slider.init(0, this.$(element).find('.slider'));

      var view_more = new ViewMore();
      view_more.$ = this.$;
      view_more.init(0, this.$(element).find('.view-more'));

      this.$(element).find('.refresh').on('click', function () {
        if (!this.$(element).find('.refresh').hasClass('disabled')) {
          this.get(element);
          this.$(element).find('.refresh').addClass('disabled');
        }
        return false;

      }.bind(this));
    }.bind(this));
  }
}